import { Icon } from "@brexhq/metal-icon";
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { MotionValue, m, useSpring } from "framer-motion";
import React from "react";

const PlayerWrapper = styled.div({
  position: "absolute",
  zIndex: 2,
  bottom: ".75rem",
  left: ".75rem",
});

const Button = styled.button({
  position: "relative",
  border: "none",
  background: "none",
  cursor: "pointer",
  color: "inherit",
  margin: 0,
  padding: 0,
});

const circleStyling = css({
  fill: "none",
  strokeWidth: 6,
  cx: 50,
  strokeDashoffset: 0,
  stroke: "currentColor",
  cy: 50,
  r: 30,
  pathLength: 1,
  transform: "rotate(-90deg)",
  transformOrigin: "50% 50%",
});

const Circle = styled.circle(circleStyling);

const MotionCircle = styled(m.circle)(circleStyling);

const PlaybackControlWrapper = styled.span({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
});

export const PlaybackButton: React.FC<{
  progress: MotionValue<number>;
  playbackState: "playing" | "paused";
  handleTogglePlayOrPause: () => void;
}> = (props) => {
  const progress = props.progress;
  const pathLength = useSpring(progress, {
    stiffness: 200,
    damping: 40,
    restDelta: 0.001,
    restSpeed: 0.001,
  });

  return (
    <PlayerWrapper>
      <Button onClick={props.handleTogglePlayOrPause}>
        <svg width="80" height="80" viewBox="0 0 100 100">
          <Circle opacity={0.2} />
          <MotionCircle style={{ pathLength }} />
        </svg>
        {props.playbackState === "playing" ? (
          <PlaybackControlWrapper>
            <Icon size={24} name="pauseFilled" />
          </PlaybackControlWrapper>
        ) : (
          <PlaybackControlWrapper>
            <Icon size={24} name="playFilled" />
          </PlaybackControlWrapper>
        )}
      </Button>
    </PlayerWrapper>
  );
};
